(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["_blocks"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('studio-preview')) {
customElements.define('studio-preview', class extends HTMLElement {
connectedCallback() {
this.controls=this.querySelector('.studio-preview__controls');
this.button=this.querySelector('.studio-preview__button');
if(!this.controls||!this.button)return;
this.expanded=this.hasAttribute('data-expanded');
this.schedule=()=>{
if(this.frame)return;
this.frame=requestAnimationFrame(()=>{
this.frame=0;
if(this.update()){
clearTimeout(this.settleTimer);
this.settleTimer=setTimeout(()=>{this.feedObserver?.disconnect();this.feedObserver=null;},1500);
}
});
};
this.toggle=()=>{
this.expanded=!this.expanded;
this.toggleAttribute('data-expanded',this.expanded);
this.button.setAttribute('aria-expanded',String(this.expanded));
this.button.textContent=this.expanded?this.button.dataset.less:this.button.dataset.more;
this.update();
};
this.button.addEventListener('click',this.toggle);
this.feedObserver=new MutationObserver(this.schedule);
this.feedObserver.observe(this,{childList:true,subtree:true});
window.addEventListener('resize',this.schedule,{passive:true});
this.schedule();
}
update() {
const grid=this.querySelector('.instafeed-new-layout-wrapper');
if(!grid||!grid.clientWidth)return false;
const items=Array.from(grid.querySelectorAll(':scope > .instafeed-new-layout-item'));
if(!items.length)return false;
const template=getComputedStyle(grid).gridTemplateColumns;
const columns=template==='none'?1:template.trim().split(/\s+/).filter(Boolean).length;
if(!columns)return false;
const visibleCount=columns*4;
const hasMore=items.length>visibleCount;
grid.classList.toggle('studio-preview__grid',hasMore);
items.forEach((item,index)=>{
const hidden=hasMore&&!this.expanded&&index>=visibleCount;
item.classList.toggle('studio-preview__item-hidden',hidden);
item.inert=hidden;
});
if(!grid.id)grid.id=this.closest('.shopify-section').id+'-studio-grid';
this.button.setAttribute('aria-controls',grid.id);
this.button.setAttribute('aria-expanded',String(this.expanded));
this.controls.hidden=!hasMore;
return true;
}
disconnectedCallback(){
this.feedObserver?.disconnect();
clearTimeout(this.settleTimer);
cancelAnimationFrame(this.frame);
this.button?.removeEventListener('click',this.toggle);
window.removeEventListener('resize',this.schedule);
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
